import color from './color'
import size from './size'

export default {
  name: 'BaseInfoFeature',
  path: 'feature',
  meta: {
    label: 'feature',
    auth: 'feature'
  },
  component: {
    name: 'Feature',
    render(c) {
      return c('router-view')
    }
  },
  children: [color, size]
}
